import { Props } from '../../native';
import Comment from '../../../sub/comment';
import * as React from 'react';
import { NativeTransparencyButton } from '../../parts/native-transparency-button';
import Description from '../../../sub/description';
import { NativeLogo } from '../../parts/native-logo';
import { NativeTitleWithAnchor } from '../../parts/native-title-with-anchor';
import { getImageSizes, NativeImage } from '../../parts/native-image';

function CarSponsorRibbon() {
    return (
        <div
            className={
                'font-normal rounded-8 text-12 w-56 border border-1 border-bluegray-200 bg-bluegray-200 text-center'
            }
        >
            Annonse
        </div>
    );
}
export function ResultCarAd(props: Props) {
    const { id, adObj, deviceType, grid, accessibilityId } = props;
    const { native } = adObj;
    const mobile = deviceType === 'mobile';
    const list = !grid && !mobile;

    return (
        <div
            id={id}
            aria-owns={accessibilityId}
            className={`ads__unit ads__unit--native`}
        >
            <Comment placement="ResultCarAd" adObj={adObj} />
            <div className={'relative ads__unit__img'}>
                <NativeImage
                    aspectClass={
                        'ads__unit__img__ratio img-format img-format--centered img-format--ratio3by2'
                    }
                    imageClass={'img-format__img'}
                    imageSizes={getImageSizes(list ? 'list' : 'grid', 'car')}
                    native={native}
                />
            </div>
            <div className={'ads__unit__content font-normal'}>
                <div
                    className={`flex flex-row justify-between text-12 ${
                        !list ? 'items-start' : 'items-center'
                    }`}
                >
                    <div
                        className={`flex ${
                            list ? 'flex-row mb-4' : 'flex-col'
                        } gap-8`}
                    >
                        <CarSponsorRibbon />
                        <div className={'text-14 text-gray-500'}>
                            {native.sponsoredBy}
                        </div>
                    </div>
                </div>
                <div className={'pb-48 flex flex-row items-end gap-4'}>
                    <div className={`flex flex-col`}>
                        <NativeTitleWithAnchor
                            className={'ads__unit__content__title font-bold'}
                            native={native}
                            accessibilityId={accessibilityId}
                        />
                        <Description native={native} className="text-12" />
                    </div>
                    <div className={'absolute bottom-8 right-8'}>
                        <NativeLogo native={native} />
                    </div>
                </div>
            </div>
            <NativeTransparencyButton
                adObj={adObj}
                className={!list ? '' : 'top-8 right-8'}
            />
        </div>
    );
}
